module.exports = __webpack_public_path__ + "img/OtherApprover.bb8fd266.svg";